(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentAccessInfoDetailController', AgentAccessInfoDetailController);

    AgentAccessInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AgentAccessInfo'];

    function AgentAccessInfoDetailController($scope, $rootScope, $stateParams, entity, AgentAccessInfo) {
        var vm = this;

        vm.agentAccessInfo = entity;

        var unsubscribe = $rootScope.$on('tikonApp:agentAccessInfoUpdate', function (event, result) {
            vm.agentAccessInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
